// Auditní historie (§22). NENÍ totožná s BCF komentáři — je to interní záznam
// změn (kdo, kdy, co, před/po). Ukládá se na topic.audit.
import { nowISO } from "./model.js";

export function auditEvent({ userId = null, topicId, action, before, after }) {
  return { timestamp: nowISO(), userId, topicId, action, before, after };
}

export function pushAudit(topic, { userId, action, before, after }) {
  if (!Array.isArray(topic.audit)) topic.audit = [];
  topic.audit.push(auditEvent({ userId, topicId: topic.id, action, before, after }));
  return topic.audit[topic.audit.length - 1];
}
